import { Product } from 'src/app/models/core/product.model';

type ProductQuota = Pick<Product, 'total_tickets_active' | 'max_quote'>;

const FULL_PERCENTAGE = 100;

/** Tickets activos del producto: lo que la barra de lotes cuenta como vendido. */
export function getSoldCount(product: Pick<Product, 'total_tickets_active'>): number {
  return product.total_tickets_active || 0;
}

/** Porcentaje del cupo vendido, entre 0 y 100. Sin cupo máximo, 0. */
export function getSoldPercentage(product: ProductQuota): number {
  if (!product.max_quote) return 0;
  return Math.min(FULL_PERCENTAGE, (getSoldCount(product) / product.max_quote) * FULL_PERCENTAGE);
}

/** Cupo definido y alcanzado: ya no se puede generar otro ticket. */
export function isProductSoldOut(product: ProductQuota): boolean {
  if (!product.max_quote) return false;
  return getSoldCount(product) >= product.max_quote;
}
